var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3647",
    "data-name": "Group 3647",
    transform: "translate(-135 -2944)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(135 2944)",
    fill: "rgba(44,222,117,0.37)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cloud-upload-svgrepo-com",
    transform: "translate(143.75 2952.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10691",
    "data-name": "Path 10691",
    d: "M7.962,23.2v-.119a24.608,24.608,0,0,1,.115-3.054A4.592,4.592,0,0,1,9.321,17.27a4.593,4.593,0,0,1,2.757-1.243,24.608,24.608,0,0,1,3.054-.115h.237a24.608,24.608,0,0,1,3.054.115,4.274,4.274,0,0,1,4,4,24.148,24.148,0,0,1,.115,3A7.461,7.461,0,0,0,23.4,8.645a7.577,7.577,0,0,0-15.1.837,7.388,7.388,0,0,0,.469,2.6,5.771,5.771,0,0,0-1.1-.105,5.612,5.612,0,1,0,0,11.223Z",
    fill: "#49c47b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10692",
    "data-name": "Path 10692",
    d: "M13.3,14c-2.5,0-3.748,0-4.524.776S8,16.8,8,19.3s0,3.747.776,4.524S10.8,24.6,13.3,24.6s3.747,0,4.524-.776S18.6,21.8,18.6,19.3s0-3.747-.776-4.524S15.8,14,13.3,14Zm2.391,4.086L13.924,16.32a.883.883,0,0,0-1.249,0l-1.767,1.767a.883.883,0,1,0,1.249,1.249l.259-.259v2.578a.883.883,0,0,0,1.767,0V19.077l.259.259a.883.883,0,1,0,1.249-1.249Z",
    transform: "translate(1.95 3.899)",
    fill: "#49c47b",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.8666c7737fd7c445f2417840c63d0074.svg";
export { ForwardRef as ReactComponent };